import {
  faBan,
  faCog,
  faEdit,
  faSave,
  faTimesCircle,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { useDispatch, useSelector } from "react-redux";
import { patientNotesGetAction } from "../../actions/patientAction";
import ConfirmDialog from "../../components/ConfirmDialog";
import ImageButton from "../../components/ImageButton";
import AddNoteForm from "./AddNoteForm";
import { formatDate } from "../../utils/helper";
const NotePopup = ({ closePopup, noteList, patientId }) => {
  const dispatch = useDispatch();
  const [notes, setNotes] = useState(noteList);
  const [activeNoteId, setActiveNoteId] = useState(0);
  const [showAddNoteForm, setShowAddNoteForm] = useState(false);
  const [canShowPopup, setCanshowpopup] = useState(false);
  const addRef = useRef(null);
  const editRef = useRef(null);
  const patientNotes = useSelector((state) => state.patient.activePatientNotes);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const patientAction = (cell, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div className="action-btn-wrapper row">
          <>
            <ImageButton
              text="Edit"
              icon={faEdit}
              onClick={() => setActiveNoteId(row.PPN_ID)}
            />
            <ImageButton
              text="Delete"
              icon={faTrash}
              isDelete="delete"
              onClick={() => {
                dispatch(
                  patientNotesGetAction(
                    "deletePatientNotes",
                    row.PPC_ID,
                    row.PPN_ID,
                    "",
                    () => {
                      dispatch(
                        patientNotesGetAction("getPatientNotes", row.PPC_ID)
                      );
                    }
                  )
                );
              }}
            />
          </>
        </div>
      </>
    );
  };
  useEffect(() => {
    setLoading(true);
    dispatch(
      patientNotesGetAction("getPatientNotes", patientId, "", "", () => {
        setLoading(false);
      })
    );
  }, [dispatch]);

  useEffect(() => {
    setNotes(patientNotes);
  }, [patientNotes]);
  const columns = [
    {
      dataField: "PPN_Note",
      text: "Note",
      sort: false,
      formatExtraData: activeNoteId,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <>
            {activeNoteId > 0 && activeNoteId === row.PPN_ID ? (
              <AddNoteForm
                hideFormAction={() => setActiveNoteId(0)}
                formRef={editRef}
                note={row.PPN_Note}
                noteId={row.PPN_ID}
                patientId={row.PPC_ID}
                canShowPopup={canShowPopup}
                setCanshowpopup={setCanshowpopup}
              />
            ) : (
              <p className="page-desc">{row.PPN_Note}</p>
            )}
          </>
        );
      },
    },
    {
      dataField: "PPN_Date_Created",
      text: "Date",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return formatDate(row.PPN_Date_Created);
      },
      headerStyle: {
        width: "100px",
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatExtraData: activeNoteId,
      formatter: patientAction,
      headerFormatter: (column, colIndex) => {
        return <FontAwesomeIcon icon={faCog} />;
      },
      headerStyle: {
        width: "190px",
      },
    },
  ];
  return (
    <Modal size="xl" show={true}>
      <Modal.Header>
        <div className="modal-title">
          <h5 className="profile-title">Patient Notes</h5>
          <FontAwesomeIcon
            icon={faTimesCircle}
            onClick={() => {
              if (canShowPopup) {
                setShowConfirmDialog(true);
              } else {
                closePopup();
              }
            }}
          />
        </div>
      </Modal.Header>
      <Modal.Body>
        <>
          <div className="add-section">
            {showConfirmDialog && (
              <ConfirmDialog
                title="Do you want to save this note?"
                acceptAction={() => {
                  activeNoteId > 0
                    ? editRef.current.click()
                    : addRef.current.click();
                  closePopup();
                }}
                acceptText="yes"
                rejectText="no"
                closePopup={() => setShowConfirmDialog(false)}
                rejectAction={closePopup}
              />
            )}
            {showAddNoteForm && (
              <div className="row">
                <div className="col-md-10">
                  <AddNoteForm
                    patientId={patientId}
                    formRef={addRef}
                    hideFormAction={() => setShowAddNoteForm(false)}
                    canShowPopup={canShowPopup}
                    setCanshowpopup={setCanshowpopup}
                  />
                </div>
                <div className="col-md-2">
                  <div className="action-btn-wrapper row">
                    <div className="mt-1">
                      <ImageButton
                        style={{ width: "130px" }}
                        text="Save"
                        icon={faSave}
                        onClick={() => {
                          setCanshowpopup(false);
                          addRef.current.click();
                        }}
                      />
                    </div>

                    <div className="mt-1">
                      <ImageButton
                        style={{ width: "130px" }}
                        text="Cancel"
                        icon={faBan}
                        isDelete="delete"
                        onClick={() => {
                          setCanshowpopup(false);
                          setShowAddNoteForm(false);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="button-section d-flex justify-content-end mr-1 mb-2">
              {!showAddNoteForm && (
                <button
                  className=" btn-orange"
                  onClick={() => {
                    setActiveNoteId(0);
                    setShowAddNoteForm(true);
                  }}
                >
                  Add Note
                </button>
              )}
            </div>
          </div>
          {loading ? (
            <p>Loading...</p>
          ) : (
            <>
              {notes?.length > 0 ? (
                <>
                  <BootstrapTable
                    classes="react-bootstrap-table"
                    keyField="PPN_ID"
                    columns={columns}
                    data={notes}
                    headerClasses="header-class"
                  />
                </>
              ) : (
                <p className="page-desc">No Notes</p>
              )}
            </>
          )}
        </>
      </Modal.Body>
    </Modal>
  );
};
export default NotePopup;
